import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { queryClient } from "../../../../../../../utils/queryClient";
import { useAppContext } from "../../../../../../../context/AppContext";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
//components
import Select from "../../../../../../../components/input/Select";
//services
import { getLandProxy } from "../../../../../../../services/Contracts/getLandProxy";
import { postLandProxy } from "../../../../../../../services/Contracts/postLandProxy";
import { deleteProxy } from "../../../../../../../services/Contracts/deleteProxy";
import { Skeleton } from "primereact/skeleton";

const Proxy = ({ setActiveIndex, id }) => {
  const columns = [
    { field: "name", header: "Nome" },
    { field: "email", header: "E-mail" },
    { field: "number", header: "Telefone" },
  ];
  const form = useForm();
  const errors = form.formState.errors;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const { data: dataProxy, isLoading: isLoadingProxy } = useQuery({
    queryKey: [`proxy${id}`],
    queryFn: () => getLandProxy(id),
    enabled: !!permissions?.includes("60")
  });
  //  // console.log(dataProxy);

  useEffect(() => {
    if (dataProxy) {
      if (dataProxy.currentAttorney.length !== 0) {
        const updateDataProxy = [...dataProxy.currentAttorney];
        updateDataProxy[0].number = updateDataProxy[0].contacts
          .map((tel) => tel.number)
          .toString();
        setTableData(updateDataProxy);
      }
    }
  }, [dataProxy]);

  const { mutateAsync: postLandProxyFn } = useMutation({
    mutationFn: postLandProxy,
    onSuccess(dataProxy, _) {
      queryClient.setQueryData([`proxy${id}`], (data) => {
        data.currentAttorney[0] = dataProxy.success.attorney;
        data.currentAttorney[0].number = data.currentAttorney[0].contacts
          .map((tel) => tel.number)
          .toString();
        setTableData(data.currentAttorney);
        return data;
      });
    },
    onError(error) {
      // console.log(error);
    },
  });

  const { mutateAsync: deleteProxyFn } = useMutation({
    mutationFn: deleteProxy,
    onSuccess(_, variables) {
      queryClient.setQueryData([`proxy${id}`], (data) => {
        data.currentAttorney.pop();
        return data;
      });
    },
    onError(error) {
      // console.log(error);
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    data.sale_id = id;
    try {
      await postLandProxyFn(data);
      toast.update(notification, {
        render: "Informação Salva com Sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
      setLoading(false);
    }
    form.reset();
  };

  const removeProxy = async (id) => {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await deleteProxyFn(id);
      toast.update(notification, {
        render: "Procurador Desvinculado com Sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
      setLoading(false);
    }
  };

  return (
    <>
      <div className="row">
        <div className="card-border me-2 my-2">
          <div className="title-container">
            <p>
              {" "}
              <i className="fa-solid fa-pen-nib me-2"></i>Procuradores
            </p>
          </div>
          <div className="row my-2 p-4">
            <h4 className="text-success">
              <i className="fa-solid fa-circle-plus mx-2"></i>Cadastro de
              Procurador
            </h4>
            <hr></hr>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-xl-4 col-md-6">
                  <Select
                    name="attorney"
                    label={isLoadingProxy ? "Carregando..." : "Procurador"}
                    errors={errors}
                    disabled={isLoadingProxy && permissions && !permissions.includes("81")}//Cadastrar Procurador  
                    control={form.control}
                    options={
                      dataProxy &&
                      dataProxy.attorneys.map((attorney) => {
                        return {
                          value: attorney.id,
                          label: attorney.name,
                        };
                      })
                    }
                  />
                </div>
                {permissions && permissions.includes("81") && ( //Cadastrar Procurador  
                  <div className="col-xl-2 col-md-3">
                    <Button
                      rounded
                      type="submit"
                      iconPos="right"
                      label="Cadastrar"
                      loading={loading}
                      icon="fa-solid fa-circle-chevron-right"
                      className="p-inputtext-sm mt-4 me-2 m-auto w-80"
                    />
                  </div>
                )}
              </div>
            </form>
            <h4 className="text-success mt-4">
              <i className="fa-solid fa-pen-nib mx-2"></i>Procurador do{" "}
              {nomenclature[1].value}
            </h4>
            <hr></hr>
            {isLoadingProxy ? (
              <Skeleton width="100%" height="150px" />
            ) : (
              <DataTable
                rows={5}
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                value={tableData}
                // loading={isLoadingProxy}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={col.body}
                  />
                ))}
                {permissions && permissions.includes("82") && ( //Excluir Procurador  
                  <Column
                    header="Excluir"
                    body={() => (
                      <div className="text-center">
                        <button
                          className="btn btn-danger btn-btn-sm"
                          type="button"
                          onClick={() => removeProxy(id)}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </div>

                    )}
                  />
                )}
              </DataTable>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Proxy;
